import { ModelPath } from "../ModelPath";
import { EachCurrentCollision } from "../EachCurrentCollision";

import { Map2 } from "./Map2";

export class ModelPathMap<V> extends Map2<ModelPath, V> {
    private readonly eachCurrentCollision: EachCurrentCollision;

    public constructor(eachCurrentCollision: EachCurrentCollision = EachCurrentCollision.AreSame) {
        super();
        this.eachCurrentCollision = eachCurrentCollision;
    }

    protected areKeyEqual(left: ModelPath, right: ModelPath): boolean {
        return left.isEquals(right, this.eachCurrentCollision);
    }

    protected getKeyHash(key: ModelPath): number {
        return key.getHash(this.eachCurrentCollision);
    }
}
